/** Ordered from start to finish so the message cannot be set to previous status if pusher event is late for some reason. */
export default [
  'sent',
  'delivered',
  'read',
  'failed',
];
